<template>
  <div class="login-box">
    <div class="login-logo">
      <img :src="$config.imgDir + '/logo.png'">
    </div>
    <form>
      <div class="login-box-body" style="border-top: 4px solid #3c8dbc;">
        <p class="login-box-msg">Entrar</p>
        <div>
          <div class="form-group has-feedback">
            <input name="email" v-model="email" type="text" required="" class="form-control" placeholder="Email">
            <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
          </div>
          <div class="form-group has-feedback">
            <input type="password" v-model="password" name="senha" id="senha" required="" class="form-control"
            placeholder="Senha">
            <span class="glyphicon glyphicon-lock form-control-feedback"></span>
            <p>{{loginError}}</p>
          </div>
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-xs-6">
              <router-link to="/forgot-password">Esqueceu a senha?</router-link>
            </div>

            <div class="col-xs-6 text-right">
              <button type="submit"
                      class="btn btn-sm btn-primary"
                      :disabled="!isValid()"
                      @click.prevent="login">
                <i class="fa fa-sign-in"></i>&nbsp; Entrar
              </button>
            </div>
          </div>
        </div>
        <br>
      </div>
     </form>
  </div>
</template>

<script>
import authentication from '@/services/authentication'

export default {
  name: 'Login',
  data: function () {
    return {
      email: '',
      password: '',
      loginError: '',
      errorsByStatusCodes: {
        401: 'Credenciais Inválidas',
        500: 'Erro - Por favor entre em contato conosco'
      },
      logo: '',
      homePathPerRole: {
        'ROLE_RESEARCHER': 'ResearcherHome',
        'ROLE_ADMIN': 'AdminHome',
        'ROLE_PARK': 'ParkHome',
        'ROLE_PARTNER': 'QuizReports'
      }
    }
  },
  methods: {
    login () {
      authentication.login(this.email, this.password)
      .then(response => {
        this.clearFormErrors()
        this.redirect()
      })
      .catch(e => {
        if (e.response) {
          this.loginError = this.errorsByStatusCodes[e.response.status] || 'Erro desconhecido. Tente novamente mais tarde.'
        } else {
          this.loginError = 'Erro ao conectar. Verifique sua conexão com a internet.'
        }
      })
    },
    clearFormErrors () {
      this.loginError = ''
    },
    redirect () {
      var redirect = this.$route.query.redirect
      if (redirect) {
        this.$router.push({path: redirect})
        return
      }

      this.$router.push({name: this.homePathPerRole[authentication.getUserRole()]})
    },
    isValid () {
      return (this.email && this.password)
    }
  },
  mounted () {
    this.logo = this.$config.logo
    document.body.classList = 'login-page'
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?317f087e